var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iconClass&&_vm.iconClass.indexOf('el-') == -1)?_c('svg',_vm._g({class:_vm.svgClass,staticStyle:{"fill":"currentColor"},attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":_vm.iconName}})]):_c('i',{class:[_vm.iconClass?_vm.iconClass:'',_vm.className]})
}
var staticRenderFns = []

export { render, staticRenderFns }